<template>
  <div>
    <div
      id="FunMeunBar"
      class="v-contextmenu"
      ref="FunMeunBar"
      v-show="showMapMeunBarFlag"
    >
      <div class="v-contextmenu-item" @click="drawLine">
        <p>绘制线</p>
      </div>
      <div class="v-contextmenu-item" @click="drawCir">
        <p>绘制圆形</p>
      </div>
      <div class="v-contextmenu-item" @click="drawSq">
        <p>绘制多边形</p>
      </div>
    </div>

    <el-dialog
      v-dialogDrag
      :title="showTitle"
      :close-on-click-modal="false"
      :modal="false"
      :append-to-body="true"
      :visible.sync="dialogVisible"
      :width="showDrawLineConlse ? '700px' : '550px'"
      :before-close="handleClose"
    >
      <template v-if="showDrawCirConlse">
        <el-form label-position="right" label-width="90px" :model="form">
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度">
                <div class="latlngDiv">
                  <el-input
                    v-model="latlng.lode"
                    oninput="value=value.replace(/[^\d]/g,'')"
                  ></el-input
                  >°
                  <el-input
                    v-model="latlng.lomin"
                    oninput="value=value.replace(/[^\d]/g,'')"
                  ></el-input
                  >'
                  <el-input
                    v-model="latlng.lose"
                    oninput="value=value.replace(/[^\d]/g,'')"
                  ></el-input
                  >"
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度">
                <div class="latlngDiv">
                  <el-input
                    v-model="latlng.lade"
                    oninput="value=value.replace(/[^\d]/g,'')"
                  ></el-input
                  >°
                  <el-input
                    v-model="latlng.lamin"
                    oninput="value=value.replace(/[^\d]/g,'')"
                  ></el-input
                  >'
                  <el-input
                    v-model="latlng.lase"
                    oninput="value=value.replace(/[^\d]/g,'')"
                  ></el-input
                  >"
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="半径（km）">
                <el-input v-model="form.radius"></el-input>
              </el-form-item> </el-col
          ></el-row> </el-form
      ></template>

      <template v-if="showDrawSqConlse">
        <el-row style="margin-bottom: 10px; margin-right: 40px">
          <el-button size="mini" style="float: right" @click="addPlot"
            >添加</el-button
          ></el-row
        >

        <el-scrollbar class="scrollMenuBox">
          <el-row v-for="(item, index) in spotOptionList" :key="index">
            <el-col :span="11">
              <div style="display: flex">
                <div
                  style="
                    min-width: 60px;
                    line-height: 40px;
                    text-align: right;
                    padding: 0 10px;
                  "
                >
                  经度
                </div>
                <div class="latlngDiv">
                  <el-input
                    max="180"
                    min="-180"
                    oninput="if(value>180)value=180;if(value.length>3)value=value.slice(0,3);if(value<-180)value=-180;value=value.replace(/[^\d]/g,'');"
                    v-model="item.lode"
                  ></el-input
                  >°
                  <el-input
                    type="number"
                    max="60"
                    min="0"
                    oninput="if(value>60)value=60;if(value.length>3)value=value.slice(0,3);if(value<0)value=0;value=value.replace(/[^\d]/g,'');"
                    v-model="item.lomin"
                  ></el-input
                  >'
                  <el-input
                    type="number"
                    max="60"
                    min="0"
                    oninput="if(value>60)value=60;if(value.length>3)value=value.slice(0,3);if(value<0)value=0;value=value.replace(/[^\d]/g,'');"
                    v-model="item.lose"
                  ></el-input
                  >"
                </div>
              </div>
            </el-col>
            <el-col :span="11">
              <div style="display: flex">
                <div
                  style="
                    min-width: 60px;
                    line-height: 40px;
                    text-align: right;
                    padding: 0 10px;
                  "
                >
                  纬度
                </div>
                <div class="latlngDiv">
                  <el-input
                    type="number"
                    max="90"
                    min="-90"
                    oninput="if(value>90)value=90;if(value.length>3)value=value.slice(0,3);if(value<-90)value=-90;value=value.replace(/[^\d]/g,'');"
                    v-model="item.lade"
                  ></el-input
                  >°
                  <el-input
                    type="number"
                    max="60"
                    min="0"
                    oninput="if(value>60)value=60;if(value.length>3)value=value.slice(0,3);if(value<0)value=0;value=value.replace(/[^\d]/g,'');"
                    v-model="item.lamin"
                  ></el-input
                  >'
                  <el-input
                    type="number"
                    max="60"
                    min="0"
                    oninput="if(value>60)value=60;if(value.length>3)value=value.slice(0,3);if(value<0)value=0;value=value.replace(/[^\d]/g,'');"
                    v-model="item.lase"
                  ></el-input
                  >"
                </div>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="dot" @click="removePlot(index)">
                <i class="el-icon-close"></i>
              </div>
            </el-col>
          </el-row>
        </el-scrollbar>
      </template>

      <template v-if="showDrawLineConlse">
        <v-line @cancelDrawToMap="cancelDrawToMap"></v-line>
      </template>

      <span v-if="!showDrawLineConlse" slot="footer" class="dialog-footer">
        <el-button @click="cancelDrawToMap">取 消</el-button>
        <el-button v-if="showDrawCirConlse" type="primary" @click="drawCirToMap"
          >确 定</el-button
        >
        <el-button v-if="showDrawSqConlse" type="primary" @click="drawSqToMap"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import vLine from "./components/Line.vue";
export default {
  data() {
    return {
      showDrawCirConlse: false,
      showDrawSqConlse: false,
      showDrawLineConlse: false,
      showTitle: "",

      form: {
        radius: "",
        lo: "",
        la: "",
      },
      formSq: {
        polygonpoints: [],
      },
      latlng: {
        lode: "",
        lomin: "",
        lose: "",
        lade: "",
        lamin: "",
        lase: "",
      },

      spotOptionList: [
        {
          lode: "",
          lomin: "",
          lose: "",
          lade: "",
          lamin: "",
          lase: "",
        },
      ],
      dialogVisible: false,

      drawLayer: null,
    };
  },
  components: {
    vLine,
  },
  computed: {
    ...mapGetters({
      showMapMeunBarFlag: "swichLayer/showMapMeunBarFlag",
      Position: "swichLayer/Position",
    }),
  },
  methods: {
    ...mapMutations({
      changeshowMapMeunBarFlag: "swichLayer/changeshowMapMeunBarFlag",
    }),
    initPosition() {
      var pixel = map.latLngToContainerPoint(this.Position);
      this.$refs.FunMeunBar.style.left = pixel.x + "px";
      this.$refs.FunMeunBar.style.top = pixel.y + "px";
    },
    drawCir() {
      this.dialogVisible = true;
      this.showDrawCirConlse = true;
      this.showTitle = "设置圆形空域";
      this.changeshowMapMeunBarFlag(false);
    },
    drawLine() {
      this.dialogVisible = true;
      this.showDrawLineConlse = true;
      this.showTitle = "设置线";
      this.changeshowMapMeunBarFlag(false);
    },
    drawCirToMap() {
      let radius = this.form.radius * 1000;
      this.form.la =
        ToDigital(this.latlng.lade, this.latlng.lamin, this.latlng.lase) - 0;
      this.form.lo =
        ToDigital(this.latlng.lode, this.latlng.lomin, this.latlng.lose) - 0;

      if (!(this.form.radius && this.form.la && this.form.lo)) {
        this.$message({
          message: "补全信息",
          type: "warning",
        });
        return;
      }

      this.drawLayer = L.circle([this.form.la, this.form.lo], {
        color: "#57c9f3",
        radius,
      });

      this.drawLayer.addTo(map);

      map.fitBounds(this.drawLayer.getBounds(), {
        maxZoom: 8,
      });

      this.dialogVisible = false;
    },
    cancelDrawToMap() {
      this.dialogVisible = false;

      this.showDrawCirConlse = false;
      this.showDrawSqConlse = false;
      this.showDrawLineConlse = false;
      this.showTitle = "";
    },
    drawSq() {
      this.dialogVisible = true;
      this.showDrawSqConlse = true;
      this.showTitle = "设置多边形空域";
      this.changeshowMapMeunBarFlag(false);
    },
    addPlot() {
      let spotOption = {
        lode: "",
        lomin: "",
        lose: "",
        lade: "",
        lamin: "",
        lase: "",
      };
      this.spotOptionList.push(spotOption);
    },
    removePlot(index) {
      this.spotOptionList.splice(index, 1);
    },
    drawSqToMap() {
      var latlngs = [];
      this.formSq.polygonpoints = [];
      this.spotOptionList.forEach((item, index) => {
        let spotOption = {};
        spotOption.lo = ToDigital(item.lode, item.lomin, item.lose) - 0;
        spotOption.la = ToDigital(item.lade, item.lamin, item.lase) - 0;
        spotOption.sortno = index;
        let latlng = [spotOption.la, spotOption.lo];
        latlngs.push(latlng);

        this.formSq.polygonpoints.push(spotOption);
      });
      this.drawLayer = L.polygon(latlngs, {
        color: "#57c9f3",
      });

      if (this.formSq.polygonpoints.length <= 2) {
        this.$message({
          message: "点数小于3",
          type: "warning",
        });
        return;
      }

      this.drawLayer.addTo(map);

      map.fitBounds(this.drawLayer.getBounds(), {
        maxZoom: 8,
      });

      this.dialogVisible = false;
    },

    handleClose(d) {
      this.showDrawCirConlse = false;
      this.showDrawSqConlse = false;
      this.showDrawLineConlse = false;
      d();
    },
  },
  watch: {
    showMapMeunBarFlag(val) {
      this.initPosition();
      if (val) {
      } else {
      }
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
#FunMeunBar {
  position: absolute;
  z-index: 3;
  padding: 10px 0;
  background-color: #fff;
  cursor: pointer;
}

.v-contextmenu {
  position: absolute;
  padding: 5px 0;
  margin: 0;
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  -webkit-box-shadow: 2px 2px 8px 0 hsl(0deg 0% 59% / 20%);
  box-shadow: 2px 2px 8px 0 hsl(0deg 0% 59% / 20%);
  list-style: none;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  z-index: 2800;
  -webkit-tap-highlight-color: transparent;
}
.v-contextmenu .v-contextmenu-item {
  padding: 0 4px;
  line-height: 1;
  color: #333;
}
.v-contextmenu .v-contextmenu-item:hover {
  background-color: #2d3035;
  color: #fff;
}
#FunMeunBar p {
  padding: 5px 10px !important;
}

/deep/.el-dialog {
  background: rgba(8, 21, 32, 0.9) !important;
  font-size: 14px;
}
/deep/ .el-dialog__title {
  color: #fff !important;
  font-size: 14px;
}
/deep/ .el-dialog__body {
  color: #fff !important;
}

/deep/ .el-form-item__label {
  color: #fff !important;

  /deep/ label {
    font-weight: 400;
  }
}
/deep/ .el-input__inner {
  padding: 0 !important;
  background-color: transparent;
  color: #fff;
  border: 1px solid #515151;
}

.latlngDiv {
  display: flex;
  justify-content: flex-start;
}

.dot {
  display: flex;
  height: 40px;
  cursor: pointer;

  i {
    margin: auto;
    font-size: 25px;
  }
}

.scrollMenuBox {
  height: 100px;
  overflow: hidden;

  .el-row {
    margin-bottom: 10px;
  }

  /deep/ .el-scrollbar__wrap {
    // 实际上我们的内容是放在这个div下面的
    // height: 100%; // 渲染出来的div.el-scrollbar__wrap默认会添加height:100%的属性。我们可以设置为105%来隐藏元素水平滚动条
    width: 106%;
    overflow-x: hidden;
  }

  .el-scrollbar__wrap ::-webkit-scrollbar {
    width: 10px;
    height: 15px;
  }
  .el-scrollbar__wrap ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    background: linear-gradient(270deg, #1a3c53 0%, #14395a 100%);
    border-radius: 9px;
    border: 1px solid rgba(151, 151, 151, 0.4);
  }
  .el-scrollbar__wrap ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  .el-scrollbar__wrap ::-webkit-scrollbar-corner {
    /*滚动条里面轨道*/

    background: rgba(0, 0, 0, 0.1);
  }
}
</style>